
function stepper(btn){
  let inpt = btn.parentNode.querySelector('input');

  btn.getAttribute('button-stepper') == 'increment' ? inpt.stepUp() : inpt.stepDown();
}
